(function(){
'use strict';

angular.module('classy').constant('SC_CART_COOKIE', 'sc_cart');
})();